import { httpHandler } from '../httpHandler'

export const getFamily = _ => httpHandler.get({url: `/dental/plans/full-family/`});
export const getCompany = _ => httpHandler.get({url: `/dental/plans/company/`});
export const geDetail = code => httpHandler.get({url: `/dental/plans/seller/${code}/details/`});